// extracted by mini-css-extract-plugin
export default {"body":"zEb2TGy4LLBDOniVbAgv"};